/**
 * @fileoverview Accept-invitation page.
 * @description Composes the auth page shell with the accept-invitation card. Route-level only —
 * the token lookup, decision-table branching, form, and error states all live in
 * AcceptInvitationCard/SetPasswordForm/InvitationErrorCard.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { AcceptInvitationCard } from '@/features/auth'
import AuthLayout from '@/shared/components/layouts/AuthLayout'

/**
 * @component
 */
function AcceptInvitationPage() {
  return (
    <AuthLayout>
      <AcceptInvitationCard />
    </AuthLayout>
  )
}

export default AcceptInvitationPage
